// KARVY preview workbook: start a background build, poll until ready, then let
// the browser download the file natively. Shared by Downloads and Commissions.
const BASE = "/api/commissions/prepare/karvy/preview-download";

// Resolves to { gaps, gapType } when Brokerage_Types OR Sub-Brokers still need
// tagging (HTTP 409). Otherwise to the final job status once the download has
// been handed off. gapType is one of:
//   'untagged_brokerage_type' — new Brokerage Types not yet tagged zero/trail
//   'unmapped_subbroker'      — raw sub-broker not in `subbroker` DB, no PAN
//                               chain resolution → operator must tag it.
export async function downloadKarvyPreview({ apiUrl, token, onProgress }) {
  const auth = { Authorization: `Bearer ${token}` };
  const startResp = await fetch(`${apiUrl}${BASE}/start`, { method: "POST", headers: auth });
  if (startResp.status === 409) {
    const j = await startResp.json();
    return {
      gaps: j?.detail?.gaps || [],
      gapType: j?.detail?.error || "unknown_gap",
    };
  }
  if (!startResp.ok) throw new Error(`start HTTP ${startResp.status}`);
  const { job_id: jobId } = await startResp.json();

  const startedAt = Date.now();
  // eslint-disable-next-line no-constant-condition
  while (true) {
    await new Promise((r) => setTimeout(r, 2000));
    const s = await fetch(`${apiUrl}${BASE}/status/${jobId}`, { headers: auth });
    if (!s.ok) throw new Error(`status HTTP ${s.status}`);
    const st = await s.json();
    const elapsed = Math.floor((Date.now() - startedAt) / 1000);
    onProgress?.(`${st.message || "Building…"} · ${elapsed}s`);
    if (st.status === "ready") {
      const dtResp = await fetch(`${apiUrl}/api/database/download-token`, { headers: auth });
      if (!dtResp.ok) throw new Error("download-token failed");
      const { token: dlToken } = await dtResp.json();
      window.location.assign(`${apiUrl}${BASE}/file/${jobId}?token=${dlToken}`);
      return st;
    }
    if (st.status === "error") throw new Error(st.error || "build failed");
    if (elapsed > 300) throw new Error("timed out after 5 minutes");
  }
}
